import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Icon from '@dc/ui-library/src/molecules/Icon/Icon';
import CheckboxList from './CheckboxList';
import { touchDeviceType, filterTypes } from './filterHelpers';
import { filterOptionPropTypes } from './propTypes';
import {
  setDefaultOptions,
  restorePreviousFiltersSetup
} from '../../../../../appState/ducks/listingPageFilters';
import { toggleXhrErrorWarning } from '../../../../../appState/ducks/listingPageSetup';

class FilterOpened extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      filterName: '',
      componentHeight: 0
    };

    this.showFiltersList = this.showFiltersList.bind(this);
    this.setSpinner = this.setSpinner.bind(this);
    this.showSpinner = false;
  }

  setSpinner(checkedFilterName) {
    const componentHeight = this.currentComponent.clientHeight;
    this.setState({ componentHeight });

    this.setState({ filterName: checkedFilterName });
    if (checkedFilterName === this.props.name) {
      this.showSpinner = true;
    }
  }

  showFiltersList() {
    this.props.restorePreviousFiltersSetup();
    this.props.toggleXhrErrorWarning(!this.props.productsPostXhrError);
    this.props.toggleOptionsListVisibility();
  }

  renderDesktopHeader() {
    return (
      <h3
        className={'dc-filter__header'}
        onClick={this.props.toggleOptionsListVisibility}
        onKeyPress={this.props.toggleOptionsListVisibility}
      >
        <span className={'dc-filter__header--closed'}>
          {this.props.label}
        </span>
        <Icon
          icon={'ChevronRight'}
          size={'large'}
          rotate={270}
        />
      </h3>
    );
  }

  renderTouchHeader() {
    return (
      <h3
        className={'dc-filter--selected__header'}
        onClick={this.showFiltersList}
        onKeyPress={this.showFiltersList}
      >
        <Icon
          icon={'ChevronRight'}
          size={'large'}
          rotate={180}
        />
        <span className={'dc-filter--selected__header--bold'}>
          Filter by:
        </span>
        {this.props.label}
      </h3>
    );
  }

  render() {
    const { props } = this;

    if (!this.props.pendingProductsRequest) {
      this.showSpinner = false;
    }

    return (
      <nav
        ref={(currentComponent) => { this.currentComponent = currentComponent; }}
        className={'dc-filter dc-filter--selected'}
      >
        {this.showSpinner
          ? (
            <Icon
              icon={'Spinner'}
              style={{
                position: 'absolute',
                zIndex: 4,
                marginTop: this.state.componentHeight > 0 && (this.state.componentHeight / 2),
                marginLeft: 'calc(50% - 20px)',
                width: '40px',
                height: '40px'
              }}
              spin
            />
          ) : ''}

        {touchDeviceType(props.deviceType)
          ? this.renderTouchHeader()
          : this.renderDesktopHeader()}

        <ul className={'dc-filter__option-list'}>
          <CheckboxList
            name={props.name}
            mobileDevice={touchDeviceType(props.deviceType)}
            type={props.type}
            options={props.options}
            maxValue={props.maxValue}
            setSpinner={this.setSpinner}
          />
        </ul>
        {props.children}
      </nav>
    );
  }
}

FilterOpened.displayName = 'FilterOpened';

FilterOpened.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.oneOf(Object.values(filterTypes)).isRequired,
  toggleOptionsListVisibility: PropTypes.func,
  toggleXhrErrorWarning: PropTypes.func,
  setDefaultOptions: PropTypes.func,
  restorePreviousFiltersSetup: PropTypes.func,
  maxValue: PropTypes.number,
  deviceType: PropTypes.oneOf(['wide', 'desktop', 'tablet', 'mobile']).isRequired,
  options: PropTypes.arrayOf(filterOptionPropTypes).isRequired,
  children: PropTypes.node,
  productsPostXhrError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  pendingProductsRequest: PropTypes.bool,
  resetPriceInputs: PropTypes.func
};

FilterOpened.defaultProps = {
  maxValue: null,
  children: null,
  setDefaultOptions: () => {},
  toggleOptionsListVisibility: () => {},
  restorePreviousFiltersSetup: () => {},
  resetPriceInputs: () => {},
  toggleXhrErrorWarning: () => {},
  pendingProductsRequest: false,
  productsPostXhrError: null
};

function mapStateToProps(state) {
  return {
    productsPostXhrError: state.listingPage.pageSetup.xhrStatus.productsPostXhrError,
    pendingProductsRequest: state.listingPage.pageSetup.xhrStatus.pendingProductsRequest
  };
}

const dispatchFunction = { setDefaultOptions, toggleXhrErrorWarning, restorePreviousFiltersSetup };

export default connect(mapStateToProps, dispatchFunction)(FilterOpened);
